import { render, staticRenderFns } from "./videoBank.vue?vue&type=template&id=727b27ed&scoped=true&"
import script from "./videoBank.vue?vue&type=script&lang=js&"
export * from "./videoBank.vue?vue&type=script&lang=js&"
import style0 from "./videoBank.vue?vue&type=style&index=0&id=727b27ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727b27ed",
  null
  
)

export default component.exports